import React from "react";
import { teamdata } from "../services/Teams";
import { Link } from "react-router-dom";
const Teams = () => {
    return (
        <>
            <div class="card text-center m-5">
                {teamdata.map((val) => (
                    <div className="team-card m-5">
                        <div class="card-body">
                            <h5 class="card-title">{val.name}</h5>
                            <p><b>{val.profile.profile}</b></p>
                            <p><b>CAPTIAN: {val.profile.captian}</b></p>
                            <p><b>VICE-CAPTIAN: {val.profile.visecaptian}</b></p>
                            <img
                                src={val.flag}
                                class="d-inline-block align-top"
                                style={{ width: "250px" }}
                                alt=""
                            />
                        </div>

                        <Link to={`/players${val.name}`} class="btn btn-primary">
                            Players Details
                        </Link>
                    </div>
                ))}
            </div>
        </>
    );
};

export default Teams;
